import { CfPageExtra, CfPageExtraConfigs } from "types/pages/types";
import { graphql, useStaticQuery } from "gatsby";

export function useGetPathTemplatePageExtra(page: CfPageExtra) {
  const { allContentfulPageExtraConfigsV2 } = useStaticQuery(graphql`
    query {
      allContentfulPageExtraConfigsV2 {
        nodes {
          pathSlug
          templateSlug
          node_locale
        }
      }
    }
  `);

  const pagesConfig = allContentfulPageExtraConfigsV2.nodes;

  const currentPageConfig = pagesConfig.filter(
    (pageConfig: CfPageExtraConfigs) => {
      if (
        pageConfig.node_locale === page.node_locale &&
        pageConfig.templateSlug === page.templateSlug
      ) {
        return pageConfig.pathSlug;
      }
      return false;
    },
  );

  return currentPageConfig.length ? currentPageConfig[0].pathSlug : "";
}
